import { conditionOperatorNames } from '@/data/events/condition-operators';
import { conditionTargetNames } from '@/data/events/condition-targets';

export const globalsConditionOperatorNames = [
    conditionOperatorNames.EQUALS,
    conditionOperatorNames.NOT_EQUALS,
    conditionOperatorNames.EXISTS,
    conditionOperatorNames.NOT_EXISTS,
    conditionOperatorNames.INCLUDES,
    conditionOperatorNames.GREATER_THAN,
    conditionOperatorNames.LESS_THAN,
];

function getConditionOperators(add = [], remove = []) {
    return globalsConditionOperatorNames.concat(add).filter(t => !remove.includes(t));
}

// if you need to restrict which condition operators are available, you can do so here
// one prop per condition
export default function getConditionOperatorMapping(condition) {
    switch (condition) {
        case conditionTargetNames.COLLECTION:
            return getConditionOperators([conditionOperatorNames.IS_EMPTY, conditionOperatorNames.IS_NOT_EMPTY]);

        case conditionTargetNames.FORM:
            return getConditionOperators([conditionOperatorNames.IS_VALID]);

        default:
            return globalsConditionOperatorNames;
    }
}
